import { render, staticRenderFns } from "./secondhand.vue?vue&type=template&id=dca6ec8a&scoped=true&"
import script from "./secondhand.vue?vue&type=script&lang=js&"
export * from "./secondhand.vue?vue&type=script&lang=js&"
import style0 from "./secondhand.vue?vue&type=style&index=0&id=dca6ec8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca6ec8a",
  null
  
)

export default component.exports